import { createFileRoute } from "@tanstack/react-router";
import { getRegion } from "@/lib/seo/regions";
import { regionRoute } from "@/lib/seo/regionRoute";

const region = getRegion("dalarna")!;

export const Route = createFileRoute("/filmproduktion-dalarna")(regionRoute(region));
